import { render, staticRenderFns } from "./StaffTrajectory.vue?vue&type=template&id=6448bdbc&scoped=true"
import script from "./StaffTrajectory.vue?vue&type=script&lang=ts"
export * from "./StaffTrajectory.vue?vue&type=script&lang=ts"
import style0 from "./StaffTrajectory.vue?vue&type=style&index=0&id=6448bdbc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6448bdbc",
  null
  
)

export default component.exports